import React, { useState, useEffect } from "react";
import jsPDF from "jspdf";

const Grocerysettlement = () => {
  const [dataa, setDataa] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  useEffect(() => {
    const fetchData = async () => {
      const vendorId = localStorage.getItem("vendorId");
      const token = localStorage.getItem("authToken");

      if (!vendorId || !token) {
        setError("Missing vendorId or token");
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          `https://backend.maamaas.com/food/settlements/vendor/${vendorId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const apiData = await response.json();

        const transformedData = [
          {
            sno: 1,
            transactionId: `TXN${apiData.settlementId}`,
            actual: `₹${apiData.totalGrandTotal.toLocaleString()}`,
            service: `₹${(
              apiData.totalServiceCharges + apiData.totalPlatformCharges
            ).toLocaleString()}`,
            totalAmount: `₹${apiData.amountAfterTds.toLocaleString()}`,
            date: apiData.settlementDate,
            status: apiData.paymentStatus || "Pending",
            payment:
              apiData.totalOnlinePayment > 0 ? "Online" : "Bank Transfer",
            note: `Settlement #${apiData.settlementId}`,
          },
        ];

        setDataa(transformedData);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  const handleDownload = (item) => {
    const doc = new jsPDF();
    const line = (label, v, y) => doc.text(`${label}: ${v}`, 10, y);

    doc.setFontSize(18);
    doc.text("INVOICE", 10, 15);

    doc.setFontSize(12);
    line("Transaction ID", item.transactionId, 30);
    line("Actual Amount", item.actual, 40);
    line("Service Charges", item.service, 50);
    line("Received Amount", item.totalAmount, 60);
    line("Date", item.date, 70);
    line("Note", item.note, 80);

    doc.save(`${item.transactionId}-invoice.pdf`);
  };

  const handleExportAll = () => {
    const doc = new jsPDF({ unit: "pt", format: "a4" });
    const startX = 40; // left margin
    let y = 60; // first row Y
    const rowH = 18; // row height
    const colW = [40, 90, 80, 80, 100, 60, 60, 60, 100]; // widths

    /* helper to strip ₹/comma for totals */
    const num = (s) => Number(String(s).replace(/[^0-9.-]/g, "") || 0);

    const totals = dataa.reduce(
      (acc, r) => ({
        actual: acc.actual + num(r.actual),
        service: acc.service + num(r.service),
        received: acc.received + num(r.totalAmount),
      }),
      { actual: 0, service: 0, received: 0 }
    );

    /* title */
    doc.setFontSize(16);
    doc.text("Settlement Report", startX, 40);

    /* ------------- header row ------------- */
    const headers = [
      "S.No",
      "Transaction ID",
      "Actual Amount",
      "Service Charges",
      "Received Amount",
      "Date",
      "Status",
      "Payment",
      "Note",
    ];

    doc.setFontSize(10);
    doc.setFillColor(177, 93, 198);
    drawRow(headers, true);

    /* ------------- body rows -------------- */
    dataa.forEach((r, idx) => {
      const body = [
        r.sno,
        r.transactionId,
        r.actual,
        r.service,
        r.totalAmount,
        r.date,
        r.status,
        r.payment,
        r.note,
      ];
      drawRow(body, false, idx % 2 === 0 ? "#f9f9f9" : "#ffffff");
    });

    /* ------------- totals row ------------- */
    const totalRow = [
      "",
      "TOTAL",
      `₹${totals.actual.toLocaleString()}`,
      `₹${totals.service.toLocaleString()}`,
      `₹${totals.received.toLocaleString()}`,
      "",
      "",
      "",
      "",
    ];
    drawRow(totalRow, false, "#e8e8e8", true);

    /* save */
    doc.save("Settlement-Report.pdf");

    /* ---------- small helper to paint a row ---------- */
    function drawRow(cells, isHeader = false, bg = null, bold = false) {
      let x = startX;
      if (bg) {
        doc.setFillColor(bg);
        doc.rect(
          startX,
          y - rowH + 4,
          colW.reduce((a, b) => a + b, 0),
          rowH,
          "F"
        );
      }
      cells.forEach((txt, i) => {
        if (bold || isHeader) doc.setFont(undefined, "bold");
        else doc.setFont(undefined, "normal");

        doc.text(String(txt), x + 2, y);
        x += colW[i];
      });
      y += rowH;
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      {/* filter bar */}
      <div
        style={{
          display: "flex",
          gap: 10,
          justifyContent: "space-between",
          marginTop: -15,
        }}
      >
        <div>
          {["Yearly", "Monthly", "Weekly", "Today"].map((l) => (
            <select key={l} style={selectStyle}>
              <option>{l}</option>
            </select>
          ))}
        </div>
        <div>
          <button style={btnStyle}>Import</button>
          {/* EXPORT → full‑table PDF */}
          <button style={btnStyle} onClick={handleExportAll}>
            Export
          </button>
        </div>
      </div>

      {/* table on screen */}
      <table
        style={{ width: "100%", borderCollapse: "collapse", marginTop: 0 }}
      >
        <thead>
          <tr style={{ backgroundColor: "#f2f2f2" }}>
            {[
              "S.No",
              "TransactionID",
              "Total Amount",
              "Charges",
              "ReceivedAmount",
              "Date",
              "Status",
              "payment",
              "Note",
              "Invoice",
            ].map((h) => (
              <th key={h} style={thStyle}>
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {dataa.map((item, index) => (
            <tr
              key={item.transactionId}
              style={index % 2 === 0 ? evenRowStyle : oddRowStyle}
            >
              <td style={tdStyle}>{item.sno}</td>
              <td style={tdStyle}>{item.transactionId}</td>
              <td style={tdStyle}>{item.actual}</td>
              <td style={tdStyle}>{item.service}</td>
              <td style={tdStyle}>{item.totalAmount}</td>
              <td style={tdStyle}>{item.date}</td>
              <td style={tdStyle}>
                <span
                  style={{
                    color: item.status === "Received" ? "green" : "orange",
                    fontWeight: "bold",
                  }}
                >
                  {item.status}
                </span>
              </td>
              <td style={tdStyle}>{item.payment}</td>
              <td style={tdStyle}>{item.note}</td>
              <td style={tdStyle}>
                {item.status === "Received" ? (
                  <button
                    onClick={() => handleDownload(item)}
                    style={downloadBtn}
                  >
                    Download
                  </button>
                ) : (
                  "—"
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

/* tiny styles */
const thStyle = {
  border: "1px solid #ddd",
  textAlign: "center",
  fontWeight: "bold",
  backgroundColor: "#b15cd6",
  color: "white",
};
const tdStyle = {
  border: "1px solid #ddd",
  textAlign: "center",
  padding: 4,
};
const evenRowStyle = { backgroundColor: "#f9f9f9" };
const oddRowStyle = { backgroundColor: "#fff" };
const selectStyle = {
  height: 35,
  marginTop: 20,
  marginRight: 10,
  borderRadius: 4,
  fontWeight: "bold",
  backgroundColor: "#b15cd6",
  color: "#fff",
  marginBottom: 5,
};
const btnStyle = {
  height: 35,
  marginTop: 20,
  marginRight: 10,
  borderRadius: 4,
  border: "none",
  backgroundColor: "#b15cd6",
  color: "white",
  fontWeight: "bold",
  padding: "0 16px",
};
const downloadBtn = {
  padding: "4px 8px",
  border: "none",
  borderRadius: 4,
  backgroundColor: "#b15cd6",
  color: "#fff",
  cursor: "pointer",
};

export default Grocerysettlement;